import { Check } from "@vibe/icons";

export function SyncWizardStepIndicator({ current, total }: { current: number; total: number }) {
  const labels = ["Select items", "Destination", "Columns"];
  return (
    <div className="flex gap-0 items-center mb-6">
      {labels.map((label, i) => {
        const step = i + 1;
        const done = step < current;
        const active = step === current;
        return (
          <div key={step} className="flex items-center">
            <div className="flex flex-col gap-1 items-center">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] transition-all"
                style={{
                  backgroundColor: done ? "#00c875" : active ? "#0073ea" : "#f6f7fb",
                  color: done || active ? "white" : "#676879",
                  fontWeight: 600,
                  border: done || active ? "none" : "1.5px solid #d0d4e4",
                }}
              >
                {done ? <Check size={12} /> : step}
              </div>
              <span
                className="text-[10px] whitespace-nowrap"
                style={{
                  color: active ? "#0073ea" : done ? "#00c875" : "#676879",
                  fontWeight: active ? 600 : 400,
                }}
              >
                {label}
              </span>
            </div>
            {i < total - 1 && (
              <div
                className="h-[1.5px] w-12 mb-4 mx-1 transition-colors"
                style={{ backgroundColor: done ? "#00c875" : "#d0d4e4" }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
